import React from 'react';

const HowItWorksSection = () => {
  return (
    <section className="py-24 max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop reveal-on-scroll">
      <div className="text-center mb-20">
        <h2 className="font-headline-md text-headline-md mb-4">How It Works</h2>
        <p className="text-on-surface-variant">Three simple steps to upgrade your trading game.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
        <div className="hidden md:block absolute top-12 left-1/4 right-1/4 h-[2px] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
        <div className="relative z-10 flex flex-col items-center text-center group stagger-item">
          <div className="w-24 h-24 rounded-full bg-surface-container border-2 border-white/5 flex items-center justify-center mb-8 group-hover:border-primary transition-all">
            <span className="material-symbols-outlined text-4xl text-on-surface-variant group-hover:text-primary">search</span>
          </div>
          <div className="text-primary font-bold text-[12px] uppercase mb-2">Step 01</div>
          <h4 className="font-bold text-headline-sm mb-4">Browse</h4>
          <p className="text-on-surface-variant max-w-xs">Explore our curated collection of 500+ premium Expert Advisors. Filter by platform, strategy, and performance metrics.</p>
        </div>
        <div className="relative z-10 flex flex-col items-center text-center group stagger-item">
          <div className="w-24 h-24 rounded-full bg-surface-container border-2 border-white/5 flex items-center justify-center mb-8 group-hover:border-primary transition-all">
            <span className="material-symbols-outlined text-4xl text-on-surface-variant group-hover:text-primary">shopping_cart</span>
          </div>
          <div className="text-primary font-bold text-[12px] uppercase mb-2">Step 02</div>
          <h4 className="font-bold text-headline-sm mb-4">Purchase</h4>
          <p className="text-on-surface-variant max-w-xs">Pay securely with crypto, card, or PayPal. Instant confirmation. No subscriptions—one-time payment, lifetime access.</p>
        </div>
        <div className="relative z-10 flex flex-col items-center text-center group stagger-item">
          <div className="w-24 h-24 rounded-full bg-surface-container border-2 border-white/5 flex items-center justify-center mb-8 group-hover:border-primary transition-all">
            <span className="material-symbols-outlined text-4xl text-on-surface-variant group-hover:text-primary">download</span>
          </div>
          <div className="text-primary font-bold text-[12px] uppercase mb-2">Step 03</div>
          <h4 className="font-bold text-headline-sm mb-4">Download &amp; Trade</h4>
          <p className="text-on-surface-variant max-w-xs">Instantly download your EA, install on MT4/MT5, and start trading. Full setup guides included with every purchase.</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
